import moment from "moment";
import { IP } from "../internalServer"
import { Tooltip } from "@mui/material";
import { shortenParagraph } from "../utils/Engagement";

const CommentsTickets = ({ data, userId }) => {
  function formatTime(timeString) {
    const time = new Date(timeString);
    let hours = time.getHours();
    const minutes = time.getMinutes();
    const period = hours >= 12 ? "PM" : "AM";

    hours = hours % 12 || 12;

    const paddedMinutes = minutes < 10 ? "0" + minutes : minutes;

    return `${hours}:${paddedMinutes} ${period}`;
  }
  return (
    <>
      <div className="reply_container flex ml-4">
        <div>
          {data?.user_id?.userType === "Student" ? (<img
            src={
              data.user_id?.profile_picture
                ? IP + data.user_id?.profile_picture.replace(/^\./, "")
                : data.user_id?.gender === "M"
                  ? data.user_id?.avatarProfile ? '/images/Boys/' + data.user_id?.avatarProfile + '.webp'
                    : "/images/Student_boy_pic.png"
                  : data.user_id?.gender === "F"
                    ? data.user_id?.avatarProfile ? '/images/Girls/' + data.user_id?.avatarProfile + '.webp'
                      : "/images/Student_girl_pic.png"
                    : "/images/default image.png"
            }
            alt="icon"
            className=""
            style={{ width: "40px", height: "40px", borderRadius: "10%", cursor: "pointer" }}
            onError={(e) => {
              if (data.user_id?.gender === "M") {
                e.target.src = data.user_id?.avatarProfile ? '/images/Boys/' + data.user_id?.avatarProfile + '.webp' : "/images/Student_boy_pic.png"
              } else if (data.user_id?.gender === "F") {
                e.target.src = data.user_id?.avatarProfile ? '/images/Girls/' + data.user_id?.avatarProfile + '.webp' : "/images/Student_girl_pic.png"
              } else {
                e.target.src = "/images/default image.png"
              }
            }}
          />) : (
            <img
              src={
                data.user_id?.profile_picture
                  ? IP + data.user_id?.profile_picture.replace(/^\./, "")
                  : data.user_id?.gender === "M"
                    ? "/images/Teacher_Male.jpg"
                    : data.user_id?.gender === "F"
                      ? "/images/Teacher_Female.png"
                      : "/images/default image.png"
              }
              alt="icon"
              className=""
              style={{ width: "40px", height: "40px", borderRadius: "10%", cursor: "pointer" }}
              onError={(e) => {
                if (data?.user_id?.gender === "M") {
                  e.target.src = "/images/Teacher_Male.jpg"
                } else if (data?.user_id?.gender === "F") {
                  e.target.src = "/images/Teacher_Female.png"
                } else {
                  e.target.src = "/images/default image.png"
                }
              }}
            />
          )
          }
        </div>
        <div className="overflow-hidden">
          <div className="flex items-center">
            <p className="mt-2 ml-3" style={{ fontSize: "15px", fontWeight: 600, color: "black" }}>{data?.user_id?.id === userId ? "You" : data?.user_id?.userType === "B4sAdmin" ? "B4SAdmin" : data?.user_id?.name}</p>
            <p className="mt-2 ml-3" style={{ fontSize: "13px", fontWeight: 400 }}>{moment(data?.created_at).calendar({
              sameDay: "[Today]",
              lastDay: "[Yesterday]",
              lastWeek: "MMM DD, YYYY ",
              sameElse: "dddd-MMM DD, YYYY ",
            })} | {formatTime(data?.created_at)}</p>
          </div>
          <div className="ml-3 comments-text">
            {data?.reply}
          </div>
        </div>
      </div>

    </>
  );
};

export default CommentsTickets;
